import { isUserFromWebView } from '@libs/utils/helpers/webviewComunication';

export default function getRedlineAppName() {
  // isUserFromWebView: app v5.x.x-
  // window.isNativeApp: app v6.x.x+
  const isInNativeApp = isUserFromWebView() || window.isNativeApp;

  return isInNativeApp ? 'ac-mobile-app' : 'ac-app';
}
